import React from 'react'
import EditableSpan from '../EditableSpan'
import Input from '../Input'

const InputInlineElement = ({
  onBlur = () => {},
  value,
  ...props
}) => {

  return (
    <Input
      autoFocus
      onBlur={onBlur}
      defaultValue={ value }
      {...props}
    />
  )
}

export const InputInline = (props) => (
  <EditableSpan {...props} inlineElementType="InputInlineElement" inlineElement={InputInlineElement} />
)

export default InputInline